import { StateSchema } from 'app/config/storeConfig/types';
import { UnitType } from 'entities/Contract';

export const getSelectedUnitTypeFilter = (state: StateSchema): UnitType => state.unitTypeFilter.selectedFilter;
